const listCurrencyWithoutFraction = ['JPY'];
const minimumFractionDigitsDefault = 2;
const minimumFractionDigits = (currencyIsoCode) => {
	return listCurrencyWithoutFraction.some((currency) => {
		return currency && currency.toLowerCase() === currencyIsoCode.toLowerCase();
	})
		? 0
		: minimumFractionDigitsDefault;
};

export default {
	methods: {
		formatPrice(price, currency) {
			const priceFormat = new Intl.NumberFormat(this.$store.state.Language, {
				style: 'currency',
				currency: currency || 'USD',
				minimumFractionDigits: minimumFractionDigits(currency),
			});
			return priceFormat.format(price);
		},
	},
};
